function createLayoutRenderData (layoutDom, initHeight) {
  if (!layoutDom || layoutDom.nodeType !== 1) {
    return
  }
  let optionKeys = []
  let cellKeys = []
  const parentOffsetTop = layoutDom.offsetTop
  layoutDom.childNodes.forEach((child) => {
    const offsetTop = child.offsetTop
    const index = child.getAttribute('data-key')
    // 认为超出。隐藏起来了。
    if (offsetTop - parentOffsetTop >= initHeight) {
      optionKeys.push(index)
    } else {
      cellKeys.push(index)
    }
  })
  return {
    optionKeys,
    cellKeys,
  }
}

export function useLayoutResizePlugin ({
  layoutDom,
  initHeight
}) {
  const data = createLayoutRenderData(layoutDom, initHeight)
  return data
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/plugins/layout-resize.js